import { TDictionaryDataKey } from './types';

export const DICTIONARY_NAME_BY_DATA_KEY: Record<TDictionaryDataKey, string> = {
  cardBrand: 'cardBrand',
  cardType: 'cardType',
  verification: 'cardTokenVerificationStatus',
};
